// extracted by mini-css-extract-plugin
export default {"wrapper":"tS-z","ratingContainer":"uS-z","ratingValue":"vS-z","starSprite":"wS-z","ratingLabel":"xS-z","error":"yS-z","errorBox":"zS-z"};